<template>
  <div style="background: #F5F2E7">
    <van-loading type="spinner" v-if="nodata"/>
<!--    <div class="about">-->
<!--      <topIcon :template="template"></topIcon>-->
<!--    </div>-->
    <div v-if="dominItem.templateId === 'temp3'">
      <div class="logo" style="display: flex;justify-content: space-between; align-items: center; padding-left: 20%"
           :class="[`${dominItem.templateId}`, `${dominItem.templateId}1`]">
        <span>{{ dominItem.logoName || 'Logo' }}</span>
        <span style="font-size: 18px">{{ nowDate }}</span></div>
      <div class="category" :class="`${dominItem.templateId}`">
          <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
              item.label
            }}</span>
      </div>
    </div>

    <div v-else>
      <div class="logo" style="display: flex;justify-content: space-between; align-items: center; padding: 10px 20%" :class="[`${dominItem.templateId}`, `${dominItem.templateId}1`]">
        <span style="font-size: 18px">{{ nowDate }}</span><span>{{ dominItem.logoName || 'Logo' }}</span></div>
      <div class="category" :class="`${dominItem.templateId}`">
          <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
              item.label
            }}</span>
      </div>
    </div>
    <div style="padding: 0 20%;">
      <div class="news-page">
        <!-- 左侧主要内容区 -->
        <div class="main-content">
          <div class="featured-article" @click="toDetail(bestItem.articleShortName)">
            <img
                :src="bestItem.articleImage"
                class="featured-img"
            />
            <h2>{{ bestItem.articleTitle }}</h2>
            <p class="threeHde" style="border-bottom: 1px solid #DADADA; padding-bottom: 15px;">
              {{ bestItem.articleIntro }}
            </p>
          </div>


          <div class="article-list">
            <div class="article-item" v-for="item in articleList" @click="toDetail(item.articleShortName)">
              <img
                  :src="item.articleImage"
                  class="article-img"
              />
              <div class="article-text">
                <h3 class="oneHde">{{ item.articleTitle }}</h3>
                <p  class="threeHde">
                  {{ item.articleIntro }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- 右侧观点栏 -->
        <div class="opinion-sidebar">
          <h2>{{ $t('con_bestnew') }}</h2>
          <div class="opinion-item" v-for="item in latestNewsList" @click="toDetail(item.articleShortName)">
            <img
                :src="item.articleImage"
                class="opinion-img"
            />
            <h3 class="twoHde">{{ item.articleTitle }}</h3>
          </div>
        </div>
      </div>

      <div class="lifestyle-page">
        <h2 style="border-bottom: 1px solid #DADADA; padding-bottom: 20px; margin-bottom: 20px">{{ $t('con_related') }}</h2>
        <div class="articles-grid">
          <!-- 第一行文章 -->
          <div class="article-item" v-for="item in recommendList1" @click="toDetail(item.articleShortName)">
            <img
                :src="item.articleImage"
                class="article-img"
            />
            <h3 class="article-title twoHde">{{ item.articleTitle }}</h3>
            <p class="article-desc threeHde">
              {{ item.articleIntro }}
            </p>
          </div>
        </div>
      </div>

      <div class="lifestyle-page">
        <h1 class="section-title">{{ $t('con_latest') }}</h1>
        <hr class="divider" />
        <!-- 第一行两篇文章 -->
        <div class="row">
          <div class="article-item" style="width: 33%" v-for="item in recommendList" @click="toDetail(item.articleShortName)">
            <img
                :src="item.articleImage"
                class="article-img"
            />
            <h3 class="article-title twoHde">{{ item.articleTitle }}</h3>
            <p class="article-desc threeHde">
              {{ item.articleIntro }}
            </p>
          </div>
        </div>
        <!-- 第二行三篇文章 -->
        <div class="row">
          <div class="article-item"  v-for="item in latestNewsList1" @click="toDetail(item.articleShortName)">
            <img
                :src="item.articleImage"
                class="article-img"
            />
            <h3 class="article-title twoHde">{{ item.articleTitle }}</h3>
            <p class="article-desc threeHde">
              {{ item.articleIntro }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="buttom">
      <div style="display: flex; flex-direction: column">
        <div style="display:flex;">
        <div class="logo">{{ dominItem.logoName || 'Logo' }}</div>
        <div class="explore">
          <span v-for="item in typeList" @click="changeType(item.id)" style="cursor: pointer">{{ item.label }}</span>


        </div>
        </div>
        <div class="img"  v-if="dominItem.nationId !== 'cn'">
          <img  v-for="item in iconListsmall" @click="openLink(item.link)" :src="item.url" alt="">
        </div>
      </div>
      <footers is00="is00" :articleListlast="articleListlast" :current="current" ></footers>

    </div>
  </div>
</template>

<script>
import topIcon from '../../icons/small.vue'
import buttomIcon from '../../icons/big.vue'
import footers from "@/components/footContent/index.vue"
import {format} from "date-fns";
import {getContentList, getLatestNews, getOne, getRecommend} from "@/api";

export default {
  components: {topIcon, buttomIcon, footers},
  props: {
    dominItem: Object
  },
  name: "index",
  data() {
    return {
      bestItem: {},
      recommendList1: [],
      latestNewsList:[],
      articleList: [],
      articleListlast:[],
      recommendList:[],
      latestNewsList1:[],
      recommendList2:[],
      nowDate: undefined,
      nodata: false,
      template: 'temp1',
      current: 1,
      iconListsmall: [
        {url: require('../../../assets/icon/linkedin.png'), link: 'https://www.linkedin.cn/'},
        {url: require('../../../assets/icon/facebook.png'), link: 'https://www.facebook.com/'},
        {url: require('../../../assets/icon/flipboard.png'), link: 'https://www.flipboard.cn/'},
        {url: require('../../../assets/icon/twitter.png'), link: 'https://twitter.com/'},
        {url: require('../../../assets/icon/instagram.png'), link: 'https://www.instagram.com/'},
      ],
      typeList: [{label: this.$t('con_home'), id: 1},
        {label: this.$t('con_BUSINESS'), id: 2},
        {label: this.$t('con_NEWS'), id: 3},
        {label: this.$t('con_AllPRESS'), id: 4},
        {label: this.$t('con_LIFESTYLE'), id: 5},
        {label: this.$t('con_AUTO'), id: 6},
        {label: this.$t('con_TECHNOLOGY'), id: 7},
        {label: this.$t('con_about'), id: 8},
      ],
    }
  },
  created() {
    if (this.$route.query.type) {
      this.changeType(Number(this.$route.query.type))
    }else {
      this.getArticleList()
      this.getArticleListlast()
      this.getLatestNewsList()
      this.getLatestNewsList1()
      this.getRecommendList()
      this.getRecommendList1()
      this.getRecommendList2()
      this.getOneList()
    }
this.nowDate = format(new Date(), this.$t('con_format'))
  },

  methods: {
    changeType(item) {
      if (item === 8) {
        item = 1
      }
      this.nodata = true
      this.current = item
      this.getArticleList()
      this.getArticleListlast()
      this.getLatestNewsList()
      this.getLatestNewsList1()
      this.getRecommendList()
      this.getRecommendList1()
      this.getRecommendList2()
      this.getOneList()
    },

    openLink(link) {
      window.open(link)
    },

    // 获取最新的一篇文章
    getOneList() {
      getOne({articleCategoryId: this.current, articleNationId: this.dominItem.nationId}).then(res => {
        if (!res.data.articleImage) {
          res.data.articleImage = require('@/assets/defore.jpg')
        }
        this.bestItem = res.data
        // this.bestInfo.uploadTime = format(new Date(this.bestInfo.uploadTime), this.$t('con_format'))
      })
    },

    // 获取文章列表
    getArticleList() {
      // this.nodata = true
      getContentList({articleCategoryId: this.current,pageNum: this.newsPageNum, pageSize: 6, articleNationId: this.dominItem.nationId}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList = res.rows
        this.nodata = false
      })
    },

    // 获取最下面文章列表
    getArticleListlast() {
      // this.nodata = true
      getContentList({articleCategoryId: this.current,pageNum: 3, pageSize: 6, articleNationId: this.dominItem.nationId}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleListlast = res.rows
        this.nodata = false
      })
    },

    // 获取最后更新的文章
    getLatestNewsList() {
      getLatestNews({articleCategoryId: this.current, pageNum: this.newsPageNum, pageSize: 5, articleNationId: this.dominItem.nationId}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.latestNewsList = res.rows
        this.newsTotal = res.total
      })
    },

    // 获取最后次更新的文章
    getLatestNewsList1() {
      getLatestNews({articleCategoryId: this.current, pageNum: 2, pageSize: 4, articleNationId: this.dominItem.nationId}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.latestNewsList1 = res.rows
        this.newsTotal = res.total
      })
    },

    //  获取推荐的文章
    getRecommendList() {
      getRecommend({articleCategoryId: this.current, pageNum: this.recommendPageNum, pageSize: 4, articleNationId: this.dominItem.nationId}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.recommendList = res.rows
      })
    },

    getRecommendList1() {
      getRecommend({articleCategoryId: this.current, pageNum: this.recommendPageNum, pageSize: 9, articleNationId: this.dominItem.nationId}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.recommendList1 = res.rows
      })
    },

    getRecommendList2() {
      getRecommend({articleCategoryId: this.current, pageNum: 2, pageSize: 4, articleNationId: this.dominItem.nationId}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.recommendList2 = res.rows
      })
    },

    //  查看详情
    toDetail(name) {
      this.$router.push(`/details/${name}?type=${this.current}`)
    }
  }
};
</script>

<style scoped lang="scss">
.news-page {
  display: flex;
  gap: 20px;
  padding: 20px;
  background-color: #f9f3e6;

  .main-content {
    width: calc(100% - 500px);
    border-right: 1px solid #DADADA;
    padding-right: 5px;
    flex: 1;

    .breaking-badge {
      background-color: red;
      color: white;
      padding: 2px 8px;
      font-size: 12px;
      font-weight: bold;
      display: inline-block;
      margin-bottom: 10px;
    }

    .top-news {
      display: flex;
      gap: 15px;
      margin-bottom: 20px;

      .news-item {
        .time {
          font-size: 12px;
          color: #666;
          display: block;
          margin-bottom: 5px;
        }
        .title {
          font-size: 14px;
          font-weight: bold;
        }
      }
    }

    .featured-article {
      margin-bottom: 20px;

      .featured-img {
        width: 100%;
        height: auto;
        margin-bottom: 10px;
      }
      h2 {
        font-size: 22px;
        margin-bottom: 10px;
      }
      p {
        font-size: 14px;
        line-height: 1.4;
      }
    }

    .article-list {
      .article-item {
        display: flex;
        gap: 15px;
        margin-bottom: 20px;

        .article-img {
          width: 150px;
          height: 100px;
          object-fit: cover;
        }
        .article-text {
          border-bottom: 1px solid #DADADA;

          h3 {
            font-size: 16px;
            margin-bottom: 5px;
          }
          p {
            font-size: 14px;
            line-height: 1.4;


          }
        }
      }
    }
  }

  .opinion-sidebar {
    width: 250px !important;

    h2 {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 15px;
      border-bottom: 1px solid #ccc;
      padding-bottom: 5px;
    }

    .opinion-item {
      margin-bottom: 15px;

      .opinion-img {
        width: 100%;
        height: 200px;
        object-fit: cover;
        margin-bottom: 10px;
      }
      h3 {
        font-size: 14px;
        font-weight: bold;
      }
    }
  }
}

.lifestyle-page {
  padding: 20px;
  background-color: #f9f3e6;

  .articles-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;

    .article-item {
      //background-color: white;
      //padding: 15px;
      border: 1px solid #eee;
      border-radius: 5px;

      .article-img {
        width: 100%;
        height: 200px;
        object-fit: cover;
        margin-bottom: 10px;
        border-radius: 5px;
      }

      .article-title {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 10px;
      }

      .article-desc {
        font-size: 14px;
        color: #666;
        line-height: 1.4;
      }
    }
  }
}
.article-text {
  width: calc(100% - 180px) !important;
}
.lifestyle-page {
  padding: 20px;
  background-color: #f9f3e6;

  .section-title {
    font-size: 28px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .divider {
    margin: 10px 0;
    border: none;
    border-top: 1px solid #ccc;
  }

  .row {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;

    .article-item {
      //background-color: white;
      //padding: 15px;
      border: 1px solid #eee;
      border-radius: 5px;

      .article-img {
        width: 100%;
        height: 200px;
        object-fit: cover;
        margin-bottom: 10px;
        border-radius: 5px;
      }

      .article-title {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 10px;
      }

      .article-desc {
        font-size: 14px;
        color: #666;
        line-height: 1.4;
      }
    }
  }
  // 第一行文章项宽度调整，使布局更贴合
  .row:first-child .article-item {
    flex: 1;
  }
  // 第二行文章项宽度调整
  .row:last-child .article-item {
    width: calc(33.333% - 13.333px);
    // 计算每列宽度，减去间距占比
  }
}

.logo {
  //width: 100%;
  //padding: 10px 20%;
  padding: 10px 0;
  background: #092647;
  box-sizing: border-box;
  font-size: 40px;
  color: #E0DAC8;
  font-weight: bold;
  text-align: left;
  border-bottom: 1px solid #fff ;
}

.logo-temp1 {
  text-align: center;
}

.logo-temp2 {
  text-align: left;
}

.category {
  width: 100%;
  padding: 0 20%;
  min-height: 50px;
  background: #DAD7CE;
  margin-bottom: 30px;
  color: #092647;
  //border-top: 2px solid var(--themeColor);
  //border-bottom: 2px solid var(--themeColor);
  line-height: 48px;

  span {
    font-weight: 700;
    font-size: 14px;
    display: inline-block;
    padding: 0 20px;
    cursor: pointer;
    position: relative;
  }

  span:hover {
    //border-bottom: 3px solid red;
    color: #000;
    transition: all .5s ease;
  }

  .choose {
    //border-bottom: 3px solid red;
    transition: all .1s ease;
    color:#000;
  }
}

.buttom {
  border-top: 5px solid #092647;
  background: #092647;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .logo{
    border: none;
  }

  display: flex;

  .explore {
    margin: 0 30px;
    display: flex;

    align-items: center;

    span {
      margin-right: 10px;
      font-size: 15px;
      display: inline-block;
      color: #E0DAC8;
    }
  }
}

.about {
  cursor: pointer;
  height: 40px;
  line-height: 40px;
  font-weight: 400;
  font-size: 17px;
  text-transform: uppercase;
  display: flex;
  justify-content: end;
  //justify-content: space-between;
  padding-right: 20px;
  color: #ffffff;
  background: #092647;
  align-items: center;

  span {
    margin-left: 20px;
    margin-right: 20px;
  }

  img {
    width: 20px;
    height: 20px;
  }

  img:nth-child(4) {
    width: 30px;
    height: 30px;
  }

  img:nth-child(5) {
    width: 30px;
    height: 30px;
  }

  img:nth-child(6) {
    width: 30px;
    height: 30px;
  }
}


.content {
  padding: 0 10% 20px;
  display: flex;
  flex-wrap: wrap;
  span{
    display: inline-block;
    margin-bottom: 10px;
    width: 50%;
  }
}

.small-title {
  font-size: 13px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  margin-left: 10px;
}

.small {
  font-size: 12px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  margin-left: 10px;
  -webkit-line-clamp: 3;
}
.img {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 30px;
  margin-bottom: 30px;
  border-bottom: 1px solid #FFFFFF;
  img{
  width: 30px;
  height: 30px;
}

  img:nth-child(3) {
    width: 40px;
    height: 40px;
  } img:nth-child(4) {
    width: 40px;
    height: 40px;
  }
  img:nth-child(5) {
    width: 40px;
    height: 40px;
  }
}
.temp1{
  padding-left: 20%;
}
.temp3{
  padding-right: 20%;
}
</style>